import Button from '~/shared/components/Buttons';
import Modal from '~/shared/components/Modal';
import { logout } from '~/shared/utils/logout';

import UserAvatar from './UserAvatar';

export default function LogOutModal({
  showModal,
  onClose,
  username,
}: {
  showModal: boolean;
  onClose: VoidFunction;
  username: string;
}) {
  return (
    <Modal showModal={showModal} size="medium" onClose={onClose}>
      <div className="w-full flex flex-col items-center mt-[48px] mb-[36px]">
        <div className="flex gap-[8px] items-center mb-[12px]">
          <UserAvatar username={username || ''} />
          <div className="leading-[20px] text-[18px] text-[#949EAC]">{username}</div>
        </div>

        <div className="leading-[24px] text-[24px] font-medium text-[#1D1D1D] mb-[43px]">
          Are you sure you want to Log out?
        </div>

        <div className="flex gap-[4px]">
          <Button className="w-[133px]" onClick={onClose}>
            Cancel
          </Button>
          <Button className="w-[133px]" variant="secondary" onClick={logout}>
            Log out
          </Button>
        </div>
      </div>
    </Modal>
  );
}
